import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class PideloImagenService {
  resolver(url: string | null | undefined): string | null {
    const valor = url?.trim();
    if (!valor) return null;

    if (
      /^(https?:)?\/\//i.test(valor) ||
      valor.startsWith('data:') ||
      valor.startsWith('blob:')
    ) {
      return valor;
    }

    const base = environment.apiUrl.replace(/\/$/, '');
    if (!base) return valor;
    return valor.startsWith('/') ? `${base}${valor}` : `${base}/${valor}`;
  }
}
